import React from 'react';

import { useDataContext } from '@/hooks/useDataContext';
import { isItemsResolver, ItemsResolver, SelectItem } from '@/types/fields';

export const useResolvedItems = <ItemValueType extends string | number>(
  source: ItemsResolver<ItemValueType> | readonly SelectItem<ItemValueType>[],
): readonly SelectItem<ItemValueType>[] => {
  const [items, setItems] = React.useState<readonly SelectItem<ItemValueType>[]>([]);
  const contextData = useDataContext();

  const resolve = React.useCallback(async (): Promise<void> => {
    if (isItemsResolver(source)) {
      const { dependencies, resolve } = source;

      const dependenciesValues = dependencies
        .map((key: string): string | null => contextData[key] ?? null)
        .filter((value: string | null): boolean => value !== null);
      // Reset it first
      setItems([]);

      try {
        const items = await resolve(...dependenciesValues);
        setItems(items);
      } catch (error: unknown) {
        console.debug(error);
      }
    } else {
      setItems(source);
    }
  }, [contextData, source]);

  React.useEffect((): void => {
    void resolve();
  }, [resolve]);

  return items;
};
